/* eslint-disable @typescript-eslint/no-explicit-any */
import { Applicant, CreditApplication, Expenses } from '../../schemas/PrequalificationSchema'
import { Enum } from '../../types/constants'

function transformLoanPurposeId(loanPurposeId: string): string {
  if (loanPurposeId === Enum.ELoanPurpose.HomeImprovement || loanPurposeId === Enum.ELoanPurpose.Other) {
    return Enum.ELoanPurpose.GoodsAndServices
  }
  return loanPurposeId
}

export function transformApplicantExpensesToApi(expenses: Expenses): Expenses {
  let ret = { ...expenses }

  // eslint-disable-next-line no-restricted-syntax
  for (const [key, value] of Object.entries(ret)) {
    if (!value && value !== 0) {
      ret = { ...expenses, [key]: null }
    }
  }

  if (ret.homeFeeTypeId === Enum.EHomeFeeType.OwnWithMortgage) {
    ret.mortgageMonthly = expenses.housingMonthly
    ret.rentMonthly = null
  } else {
    ret.rentMonthly = expenses.housingMonthly
    ret.mortgageMonthly = null
  }

  return ret
}

export function transformApplicantDataToApi(applicant: Applicant) {
  const expenses = transformApplicantExpensesToApi(applicant.expenses)

  return { ...applicant, expenses } as Applicant
}

export function transformCreditApplicationToDraft(creditApplication: CreditApplication): CreditApplication {
  const loanPurposeId = transformLoanPurposeId(creditApplication.loanPurposeId)
  const toDraftCreditApplication = {
    ...creditApplication,
    loanPurposeId,
    applicant: transformApplicantDataToApi(creditApplication.applicant),
  } as CreditApplication

  return toDraftCreditApplication
}
